import React from 'react';
import styled from 'styled-components';
import { useStandardAlertStore } from './store/portal/alertStore';
import Alert from '../portal/Alert';
import SystemAlertComp from '../component/alert/SystemAlertComp';
import AlertComp from '../component/alert/AlertComp';
import ConfirmComp from '../component/alert/ConfirmComp';
import { AlertType } from './enum/EnumRepository';
import MobileConvertWrapper from './component/MobileConvertWrapper';
import AlertCompMobile from '../component/alert/mobile/AlertCompMobile';
import ConfirmCompMobile from '../component/alert/mobile/ConfirmCompMobile';
import SystemAlertCompMobile from '../component/alert/mobile/SystemAlertCompMobile';


const AlertTemplate: React.FC = () => {
  const { queue } = useStandardAlertStore();

  const renderAlert = () => {
    switch (queue[0]?.type) {
      case AlertType.EMERGENCY:
      case AlertType.MAINTENANCE:
        return (
          <MobileConvertWrapper
            onlyMobileChildren={<SystemAlertCompMobile />}
            onlyNotMobileChildren={<SystemAlertComp />}
          />
        );
      case AlertType.ALERT:
        return (
          <MobileConvertWrapper
            onlyMobileChildren={<AlertCompMobile />}
            onlyNotMobileChildren={<AlertComp />}
          />
        );
      case AlertType.CONFIRM:
        return (
          <MobileConvertWrapper
            onlyMobileChildren={<ConfirmCompMobile />}
            onlyNotMobileChildren={<ConfirmComp />}
          />
        );
    }
  };

  if (queue.length === 0) return null;

  return (
    <Alert>
      <AlertOverlay>
        {renderAlert()}
      </AlertOverlay>
    </Alert>
  );
};


const AlertOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: transparent;
  backdrop-filter: blur(1.5px);

  z-index: 8888;
`;


export default AlertTemplate;